module.exports = __webpack_public_path__ + "img/Ballon_Gaz.c7ac590c.svg";